module.exports = __webpack_public_path__ + "static/media/thum1.7f2fffa6.jpg";